import AxiosInstance from "../config/AxiosInstance";

export interface LocationItem {
    id: string;
    companyId: string;
}

export interface TenderPayload {
    tenderCode: string;
    tenderName: string;
    tenderType: number;
    maxPaymentRestriction?: number;
    icon: string;
    requireReference: boolean;
    position: number;
    promotionsId?: string;
    location: LocationItem[];
    openCashDrawer?: boolean;
    groupOther?: boolean;
}

export const uploadFileIcon = async (payload: FormData) => {
    try {
        const { data } = await AxiosInstance.post('/api/finex/files/upload', payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

export const getDetailDeviceTender = async (id: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/device-tender/${id}`);
        return { data };
    } catch (error) {
        throw error;
    }
}

export const createDeviceTender = async (payload: TenderPayload) => {
    try {
        const { data } = await AxiosInstance.post('/api/device-tender', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

export const getListDeviceTender = async (page: number, limit: number, searchValue: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/device-tender/list`, {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

export const updateDeviceTender = async (id: string, payload: TenderPayload) => {
    try {
        const { data } = await AxiosInstance.put('/api/device-tender/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

export const deleteDeviceTender = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/device-tender/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}